export default [
  {
    action: `manage`,
    subject: `dashboard`
  }
];
